import { z } from 'zod';

export const NavigationLabelSchema = z.object({
  _type: z.string(),
  thesauruses: z.array(
    z.object({
      language: z.string(),
      languageCode: z.string(),
      terms: z.record(z.string(), z.string()),
    })
  ),
});
